import React from 'react';
import styles from './style.module.css';
import StepSixForm from '../../components/forms/step-six';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Money Then</p>
        <h2 className={styles.mainTitle}>What I owe</h2>
        <StepSixForm/>
    </div>
);
